import { render, staticRenderFns } from "./PageTitleBar.vue?vue&type=template&id=6565b7f9"
import script from "./PageTitleBar.vue?vue&type=script&lang=ts"
export * from "./PageTitleBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports